import React from 'react';
import NPPanel from '../../NPPanel';
import { Col, Row, FormGroup } from 'react-bootstrap';
import Select from 'react-select';
import NPReactTable from '../../NPReactTable';
import axios from 'axios';
import constants from '../../util/constants';
import LoadingSpinner from '../../LoadingSpinner';

const { API_BASE_URL } = constants;
const DEFAULT_YEAR_SELECT = { label: 'All years', value: null };

class ProductionCycle extends React.Component {
    constructor(props) {
        super(props);

        this.getColumns = this.getColumns.bind(this);
        this.getProductionCycles = this.getProductionCycles.bind(this);
        this.getProductionCycleYears = this.getProductionCycleYears.bind(this);
        this.handleyearChange = this.handleyearChange.bind(this);

        this.state = {
            header: this.props.apiToken ? {
                'Authorization': 'Bearer ' + this.props.apiToken,
                'Accept': 'application/octet-stream'
            } : {},
            availableYears: [],
            selectedYear: DEFAULT_YEAR_SELECT,
            sorted: [],
            page: 0,
            pageSize: 20,
            resized: [],
            filtered: [],
            isLoading: true,
            data: []
        };

        this.getProductionCycles(null);
        this.getProductionCycleYears();
    }



    handleyearChange(select) {
        this.setState({ selectedYear: select });
        this.getProductionCycles(select.value);
    }

    getProductionCycles(value) {

        this.setState({ isLoading: true });
        axios.get(API_BASE_URL + `allocation/getproductioncycles/?year=${value}`, { headers: this.state.header })
            .then(result => {
                this.setState({ data: result.data, isLoading: false });
            })
            .catch(error => {
                this.setState({ isLoading: false })
            })



    }

    getProductionCycleYears() {
        axios.get(API_BASE_URL + 'allocation/getproductioncycleyears', { headers: this.state.header })
            .then(result => {
                this.setState({ availableYears: result.data });
            })
    }


    getColumns() {
        return [{
            Header: 'Year',
            accessor: 'Year',
            maxWidth: 60
        },
        {
            Header: 'Machine',
            accessor: 'Machine',
            maxWidth: 70
        },
        {
            Header: 'Grade',
            accessor: 'Grade',
            maxWidth: 70
        },
        {
            Header: 'M1',
            accessor: 'M1'
        },
        {
            Header: 'M2',
            accessor: 'M2'
        },
        {
            Header: 'M3',
            accessor: 'M3'
        },
        {
            Header: 'M4',
            accessor: 'M4'
        },
        {
            Header: 'M5',
            accessor: 'M5'
        },
        {
            Header: 'M6',
            accessor: 'M6'
        },
        {
            Header: 'M7',
            accessor: 'M7'
        },
        {
            Header: 'M8',
            accessor: 'M8'
        },
        {
            Header: 'M9',
            accessor: 'M9'
        },
        {
            Header: 'M10',
            accessor: 'M10'
        },
        {
            Header: 'M11',
            accessor: 'M11'
        },
        {
            Header: 'M12',
            accessor: 'M12'
        },
        ]
    }

    render() {
        const years = this.state.availableYears ? [DEFAULT_YEAR_SELECT, ...this.state.availableYears.map((y) => ({ label: y, value: y }))] : [];
        const data = this.state.data;

        return (
            <NPPanel>
                {this.state.isLoading ? <LoadingSpinner isLoading={this.state.isLoading} /> : 
                <Row>
                    <Col xs={12}>
                        <div>
                            <legend className="mylegend capacityLegend">Production cycles</legend>
                                <FormGroup className="select">
                                    <div className="addYear">
                                    <Select isSearchable={true}
                                        styles={{
                                            valueContainer: (provided) => ({
                                                ...provided,
                                                minWidth: '50px',
                                                width: 150
                                            }),
                                        }}
                                        isClearable={false}
                                        options={years}
                                        menuContainerStyle={{ zIndex: 1000 }}
                                        value={this.state.selectedYear}
                                        onChange={evt => {
                                            this.handleyearChange(evt);
                                        }}
                                        placeholder='Select year'
                                    />
                                    </div>

                                </FormGroup>
                                <NPReactTable
                                    getTdProps={(state, rowInfo, column, instance) => {
                                        return {
                                            style: {
                                                overflow: 'visible'
                                            }
                                        }
                                    }}
                                    className="margin-top-5 np-react-table"
                                    data={data}
                                    sortable
                                    filterable
                                    minRows={5}
                                    columns={this.getColumns()}
                                    defaultPageSize={10}
                                    // Controlled props
                                    sorted={this.state.sorted}
                                    page={this.state.page}
                                    pageSize={this.state.pageSize}
                                    expanded={this.state.expanded}
                                    resized={this.state.resized}
                                    onResizedChange={resized => { this.setState({ resized }) }}
                                    onPageChange={
                                        page => {
                                            this.setState({ page, expanded: {} });
                                        }
                                    }
                                    onPageSizeChange={(pageSize, page) => {
                                        this.setState({ page, pageSize, expanded: {} });
                                    }
                                    }
                                />
                        </div>
                    </Col>
                </Row>}
            </NPPanel>
        )
    }
}


export default ProductionCycle;